import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ReportingRoutingModule } from './reporting-routing.module';
import { ReportingPageComponent } from './reporting-page/reporting-page.component';
import { ReportingFilterOptionsResolver } from './resolvers/reporting-filter-options.resolver';
import { SeedingReportFormComponent } from './seeding-report-form/seeding-report-form.component';
import { ReactiveFormsModule } from '@angular/forms';
import { SharedModule } from '../shared/shared.module';
import { ReportingService } from './services/reporting.service';
import { TransplantReportFormComponent } from './transplant-report-form/transplant-report-form.component';
import { PollinationReportFormComponent } from './pollination-report-form/pollination-report-form.component';
import { HarvestReportFormComponent } from './harvest-report-form/harvest-report-form.component';
import { SamplingReportFormComponent } from './sampling-report-form/sampling-report-form.component';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { CapacityReportFormComponent } from './capacity-report-form/capacity-report-form.component';

@NgModule({
  imports: [
    CommonModule,
    ReportingRoutingModule,
    ReactiveFormsModule,
    BsDatepickerModule.forRoot(),
    SharedModule
  ],
  declarations: [
    ReportingPageComponent, 
    SeedingReportFormComponent, 
    TransplantReportFormComponent,
    PollinationReportFormComponent,
    HarvestReportFormComponent,
    SamplingReportFormComponent,
    CapacityReportFormComponent
  ],

  providers: [ReportingFilterOptionsResolver, ReportingService]
})
export class ReportingModule { }



// WEBPACK FOOTER //
// F:/PHAZP5152IS01-2/_work/98/s/src/app/reporting/reporting.module.ts